import { useFrontasticSelector } from '../../../../redux/store';
import { useDispatch } from 'react-redux';

export interface UsePageLoading {
  isLoading: boolean;
  hideContent: boolean;
  dispatchPageLoadingStart(hideContent?: boolean): { type: string };
  dispatchPageLoadingDone(): { type: string };
  suppressEventListeners(timeout?: number): void;
}

export function usePageLoading(): UsePageLoading {
  const dispatch = useDispatch();

  const { isLoading, hideContent } = useFrontasticSelector((state) => {
    return state.pageLoading;
  });

  const dispatchPageLoadingStart = (hideContent: boolean = true) => {
    if (hideContent) {
      return dispatch({ type: 'FRONTASTIC_BRIDGE_PAGE_LOAD_START' });
    }
    return dispatch({ type: 'FRONTASTIC_BRIDGE_PAGE_LOAD_START_WITHOUT_HIDDEN_CONTENT' });
  };

  const suppressEventListeners = (timeout = 500) => {
    dispatch({ type: 'FRONTASTIC_BRIDGE_SUPPRESS_EVENT_LISTENERS' });
    setTimeout(() => {
      dispatch({ type: 'FRONTASTIC_BRIDGE_DONT_SUPPRESS_EVENT_LISTENERS' });
    }, timeout);
  };

  const dispatchPageLoadingDone = () => dispatch({ type: 'FRONTASTIC_BRIDGE_PAGE_LOAD_DONE' });

  return {
    isLoading,
    hideContent,
    dispatchPageLoadingStart,
    dispatchPageLoadingDone,
    suppressEventListeners,
  };
}
